/**
 * Undo / redo pentru editorul planului. Pur: fiecare pas intoarce o stare
 * noua. Se tin cel mult LIMIT pasi inapoi.
 */
export type History<T> = { past: T[]; present: T; future: T[] }

export const LIMIT = 100

export function start<T>(present: T): History<T> {
  return { past: [], present, future: [] }
}

/** Un pas nou; ce era "inainte" (redo) se pierde. Acelasi obiect = niciun pas. */
export function commit<T>(h: History<T>, next: T): History<T> {
  if (next === h.present) return h
  const past = [...h.past, h.present]
  return { past: past.length > LIMIT ? past.slice(past.length - LIMIT) : past, present: next, future: [] }
}

export function undo<T>(h: History<T>): History<T> {
  if (h.past.length === 0) return h
  const prev = h.past[h.past.length - 1]
  return { past: h.past.slice(0, -1), present: prev, future: [h.present, ...h.future] }
}

export function redo<T>(h: History<T>): History<T> {
  if (h.future.length === 0) return h
  const [next, ...rest] = h.future
  return { past: [...h.past, h.present], present: next, future: rest }
}
